import { render, staticRenderFns } from "./ProjectsListTable.vue?vue&type=template&id=78589f7d&"
import script from "./ProjectsListTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports